var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-ht",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M0 0h640v240H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "none",
    d: "M244.3 179.7h151.4v120.5H244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    stroke: "#016a16",
    strokeWidth: 0.3,
    d: "m350.5 266.8-31 1-30.7.3s-15.8 5.8-22.3 7.1c-6.4 1.3-5.6 3.4-10.5 4.6-4 .9-4.5 1.1-6.8 1.3-1.5 0-3.2 1.2-5 2.4v16.7h151.5v-15.9c-1.6-.9-3.2-1.5-4.8-2-2.2-.8-3.7-1.6-7.7-2.5-5-1.1-4.2-3.3-10.6-4.6-6.5-1.3-22.1-8.4-22.1-8.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80) scale(1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.5 143.5h1.4l2.6 10.7-.6 3.4-3.4-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m243 136.3 1 8.3h1l-2-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.7 154.6-4.3-11.5 1.6-.1 5 14-2.3-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m239.4 136.5 1.8 8h1.4l-3.2-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.9 150.6-2.5-5.5 1-.2 4.7 9-3.2-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m236 138.8 2.9 7.6h1.4l-4.2-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m242.3 151.4-11.5-12.5c-3.6 2.8-2.9 8-2.9 8l13 10.2 1.3-5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m248.9 158.2-8.5-8.6c-3.6.2-.8 5.5-.6 6.2l9 7.7v-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1 156.8 230.6 138l-.7.5 18.6 20.6-.4-2.3zm-18.5-20-.4-.5v-.9l-3.6-2.3 1.6 3.7 1.3.2.3.4.8-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7 138.1a8.4 8.4 0 0 1 2.7-2.2l1 1.5-2.2 1.8-1.5-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#0a328c",
    d: "m225.8 141.3.6 1c.4-.1 4-3.5 4-3.5h2.7l.7-.9c-2-2-3.7.3-3.7.3l-4.3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#d20014",
    d: "M228 143c0-1 1.8-3.2 2-3.3 1.3.4 2.5 1.2 3.9-1.8-1.2 1.4-3.5 0-3.5 0l-1 .8v.4l-3 2.8 1.5 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "m237.3 154.7-14.4-11.4c-2.5 2.5-.4 10.2-.4 10.2l14 7.6.7-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m249.2 164-11.9-9.6c-4 .6-.8 6.5-.6 7.2l12.5 6.8v-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.7 162-25.6-19.2-.5.6 26.8 21-.7-2.4zm-26.8-20.2-.4-.4-.2-.8-4-1.7 2.3 3.3h1.3l.4.4.6-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.3 143.4a8.2 8.2 0 0 1 2.3-2.6l1.2 1.3-1.8 2.1-1.7-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#0a328c",
    d: "M219 146.6v1.1c.4-.2 3.7-3.7 3.7-3.7l2.5-.5.6-.8c-1.8-2.1-3.7.7-3.7.7l-3.2 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#d20014",
    d: "M221 148.5c-.2-1 1.2-3.8 1.4-4 1.6.5 3 1.2 3.5-2-1 1.6-3.5.4-3.5.4l-.8 1v.5l-2.5 3.3 1.9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    d: "M236.2 161.7a2783.3 2783.3 0 0 1-18.5-10.5c-1.3 2.3-.1 5.5.5 6 0 1.5-.6 2.3.7 5.5.4 2 1.3 3.9 2.7 5 1.6 6.4 8.2 6.9 10.7 1.6l4-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    d: "m248.3 168.5-12.5-7.3c-4 .5 0 8 .3 8.7l12.2 4.3v-5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.2 165.8-28.3-15-.5.6 30 16.7-1.2-2.3zM216.5 150l-.5-.3-.3-.8-4.1-1 2.7 2.9 1.2-.2.6.3.4-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.2 151.8c.4-1 .8-1.9 1.8-3l1.4 1.1-1.4 2.4-1.8-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#0a328c",
    d: "m214.1 155.2.6 1.2 3-4.6 2.5-.9.5-1c-2-1.8-3.5 1.4-3.5 1.4l-3.1 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#d20014",
    d: "M216.8 156.8c-.2-1 .5-4.2.7-4.3 1.5.5 2.8.6 3.2-2.6-1 1.5-3.3 1-3.3 1l-.7 1 .1.4-2 4 2 .5z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 499.9 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80) scale(1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    stroke: "#016a16",
    d: "m248.8 125.6-.5 9h2.9l-.4-9 3-.3-.3-3.6-7.5.3v3.2l2.8.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b",
    fill: "#016a16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.8 121.9c-7.8-7.8-13.9-4-15.3-2.9 1 .2 1.8-.4 2.3-.5l-1 1.2s2.5-1 2.8-1c-.4.3-.8 1-.8 1 .2 0 1.6-1.1 1.8-1.1-.4.4-.5 1.5-.5 1.5l1.2-.5c.3.2-.1.6.1.6 2-.2 4.7 1.7 5 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9 123.3c-.8-1.8-15.6-5-18.6.3 1.2.3 2.3-1 2.3-1v1.2l1.9-1.6-.7 1.6 1.5-1.3v1.3l2-2-.3 1.1 1.7-.7-.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2 123.6c-3.8-2.5-9.6-.8-9.6-.8-3.8 2-5.8 1.7-6.2 5.6.3-.1 1.3-1.4 1.3-1.4l.8 1.5.2-2.1.6 1.7 1-2.8.2 1.9 1.4-1.9.6.6.6-1.5.6 1s1-.6 1.5-.3l1-1.2.3.9 1-1 .3.7.9-.8v.6h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4 124c-2.7 0-10.3 2.9-12.2 5.8a13.3 13.3 0 0 1 1.3-.6l.3 1.2.5-1.2.1 1c.3-.8.6-.8 1.2-.1l.2-1.1.3 1 .5-1.1s.3 1.2.5 1.2c0 0 .8-2.2 1.2-2.3l.1 1.4.5-1.4.5 1v-1.4l.6 1s.2-1 .6-1.2l.8.7 3.4-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.9 124.7c-3.5 1.3-6.7 6.2-6.4 8.2 1.5-2 1.2-1.7 1.9.6 0 0 .2-2 .5-2.2l.5 1.4.1-1.9h.5l-.1-1.1.7.5c-.2-.7-.3-.9.4-1.5 0 0-1 .1-.2-1.5l.7.6s-.2-.7 0-1l2.6-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.2 125-1.3 2.6.7.2-1.6 1.1 1.3-.1s-2 .7-2.2 2.7l2-1s-1.7 1.8-2 2.9l1.3-1s-1.2 1.2-1 3l.9-1c-.2 2.3-.2 2.5.8 4.2 0 0-.2-2.6 0-3l2.3 2.4-1.2-3.3s1.4 2 2.2 1.9l-1.8-2.7 1.8 1.4-2-3 1.8.6s-1.3-1.7-1.2-2.8l1.3 1.4s-.5-1.5-.4-2l.7.1-1.3-1.4.9-.2-.1-1 .6-.1v-1.1m-1.1 0c-2.2 3-1.1 7.5-2.4 9.9"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 499.9 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 166.5s1.1-10 1.1-14.2c0-3.4-.8-10.8-.8-10.8H248s-.5 7.4-.4 10.8c0 4.2 1.1 14.2 1.1 14.2h2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.7 142h4l-.5-2.7h-2.9l-.6 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 139.8h3.5l-.7-2.7h-2.2l-.7 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2 137.7h3l-.6-2.7h-1.9l-.5 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.7 134.7h-2l-.3 1h2.5l-.2-1zm.4 29.7h-2.6m2.8-2h-3m3.4-2h-3.8m4-2.1h-4m4-2.2h-4.1m4.2-2h-4.4m4.4-1.7h-4.6m4.6-2.2h-4.6m4.5-2.1h-4.5m4.3-2.2h-4.1m3.9-2h-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#0a328c",
    d: "M250 119c-.8-.3-2.3-1.3-1.9-1.9l.7-1.2c1-2.2 0-1.4 0-2-.2-.8 3.8-.2 3.8 1.3 0 .5-.3.2-.2 2.6l-.8 1.5a3.5 3.5 0 0 1-1.7-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.4 125-1-.9.3-7.1 1 .3-.3 7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#d20014",
    d: "M251.7 119.3c.6-.4 1-1.5.6-2.1-1-1.3-1.7-.8-3.4-1.4-.3.4-1 1-.9 1.6 2.3 1 1.4.2 2.2.3.4 0 .6.5 1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80) scale(1.6)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "matrix(1 0 0 -1 0 320.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M238.4 161.8c0 1.2-.9 2.3-1.9 2.3s-1.8-1-1.8-2.4v-1.2h3.7v1.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.5,
    cy: 160.1,
    fill: "#fff",
    stroke: "none",
    rx: 1.8,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016a16",
    stroke: "#f1b517",
    d: "m236.1 161-.3-3.2h1.4l-.2 3.3h-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    fill: "#016a16",
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M238.5 160.1c-.2.5-1 .9-2 .9s-1.7-.4-2-.9a.8.8 0 0 0 0 .4c0 .7.9 1.2 2 1.2 1.2 0 2.1-.5 2.1-1.2a.8.8 0 0 0 0-.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246 172.8-7-2.2-3.1-5.3-10.9-.5.4 4 9.3 1.7.8 1.6 10.7 3-.2-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#503200",
    d: "m238.7 174.3-11.2-16.5-.5.5 11 16.4.7-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m228.6 158.5-1.2-2c-.3-.4-.6-.5-1.1-.2-.5.2-.4.7-.2 1.1l1 1.9 1.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 164.1-22.5-2.3-.6 3.3 22.4 2.3.7-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217 161-.5 4.5h1l.6-4.1-1-.4zm3.8.7-.2 4.1h.6l.5-3.5-.8-.6zm15.3 1.8-.6 3.8h1.1l.5-3.8h-1zm3.3.1-.7 4.4 1.2.2.4-2.3c0 .5.5.8 1 .8.6 0 1-.5 1-1 0-.6-.4-1-1-1a1 1 0 0 0-1 .6l.3-1.6-1.2-.1zm-8 .7-3.2 3.5.4.4 4-2.7-1.3-1.2zM224 173l3.1-3.5-.3-.4-4 2.7 1.2 1.2zm8.1-.9-3.7-2.9-.4.3 3 3.8 1.1-1.2zm-9.3-6.7 3.9 2.8.4-.3-3-3.8-1.3 1.3zm4.2-2.3.4 4.6h.5l1.2-4.5-2.1-.1zm1.2 11-.3-4.5h-.6l-.7 4.6h1.6zm5.1-6-4.8.4v.5l4.8.6V168zm-11.4 1.5 4.7-.7v-.4l-4.8-.5v1.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 227.7,
    cy: 168.6,
    rx: 1.3,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeLinecap: "round",
    d: "M234.4 168.6c0 3.5-3 6.5-6.7 6.5a6.6 6.6 0 0 1-6.7-6.5c0-3.6 3-6.5 6.7-6.5a6.6 6.6 0 0 1 6.7 6.5zm-1.3 0a5.3 5.3 0 0 1-5.4 5.2 5.3 5.3 0 0 1-5.4-5.3 5.3 5.3 0 0 1 5.4-5.1 5.3 5.3 0 0 1 5.4 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.5 165.3-1-.8m8.5 0 1-1m1 9.2-1.1-.9m-8.4 1.9 1-1m21.7-10.6 1.1 6-.9.4-1-6.3h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M245.6 161.4c-.5-.3-1.2.1-2.4-1.3-1.9 1.7 0 2 .2 3.7.5.2.9-1.4 2.3-1.5l2.3-.2-.5-.7h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m246.4 162.5-.2-1.7c-.3-.7-1-.1-1 .2l.2 1.7 1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M240.8 167.4v1.6c-.6.2-.5.6-.5 1.2v4.7c-.1.4-.7.4-1 .6-.3.3-.2.8 1 1l1 .1c1.5-.3 1.8-.8 1-1-.3-.2-.9-.4-1-.6v-1.2h1c.2 0 .7-.6.7-1.1v-2.5c0-1.4-1-1.6-1.4-1.5v-1.3h-.8zm1.6 2.7c0-.4-.6-.8-.8-.8-.2 0-.7.5-.7.9v1c0 .4.3 1.6.9 1.7.2 0 .6-.4.6-.8v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234.3 172.3c-.7-.2-.7 1.2-.7 1.2h1c.5.2.8.8.6 1.2-.3.2-2.2-.5-2.3 0 .3 1.9 2.9 2.6 3.8 1.8.9-.9 1.1-3-1.8-3.7l-.6-.5zm.6.6-.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215 173-1-4m2.1 3.8-1.5-3.1m4 2.3-3.3-1.8m4.8 1.4-6.2-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#d20014",
    d: "m210.2 166-2.6.1c-.2.1.5.9.4 1.1-.6 1.1-4.4 1-4.7.8-.5-.5 3.5-.8 3.6-1 0-.4-.6-1.2-.5-1.7 0-.7 1.7-1 1.7-1l2.1 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#503200",
    d: "m213.2 168-5-4.2s-.3-.2-.5 0 0 .4 0 .4l5.4 4.4.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.2 172.2-4.2-3.6-.3-1-.8.6c-.3.2-.6.8-.6.8h1.1l3.6 3.4 1.1-.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.5,
    cy: 177.1,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.6,
    cy: 175.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.1,
    cy: 176.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.2,
    cy: 177.4,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 177.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.8,
    cy: 177.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.2,
    cy: 177.6,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 176.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.6,
    cy: 176.4,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.1,
    cy: 176.2,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.4,
    cy: 175,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.8,
    cy: 174.9,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M236.5 178c0-.3-.8-.2-.8-.6 0-.4 1.2 0 1.3.3.7-.6 1-.2 1.4 0 .6-.8 1.3-.8 2-.2.4-.4 1.4-.3 1.7.2.7-.6 1.3-.5 1.7 0 .2-.3.5-.3.7 0 .3-.7 1.2-.5 1.6 0 .3-.4.7-.1 1.1.1.3-.2.8-.2.8 0 0 .4-.6.3-.6.6 0 .2.4 0 .4.4 0 .3-.6.4-.7 0-.3.4-1.1.2-1.2-.2a.8.8 0 0 1-1.2 0c-.3.2-.7.2-.8 0-.5.5-1.4.4-1.7-.2h-.3a1 1 0 0 1-1.5 0c-.9.6-1.4.4-1.9 0-.5.7-1.4.7-1.5 0-.4.3-1.2.4-1.2 0 0-.2.7-.1.7-.4zm1.6.1c0 .2-.2.3-.4.3s-.4-.1-.4-.3.1-.2.4-.2.4.1.4.2zm1.9-.2c0 .2-.3.3-.6.3s-.5-.1-.5-.3c0-.1.2-.3.5-.3s.5.2.5.3zm3.5.2c0 .2-.2.3-.5.3s-.4-.1-.4-.3c0-.1.2-.3.4-.3s.5.1.5.3zm-1.9 0c0 .2-.2.3-.5.3s-.4-.1-.4-.4c0-.2.2-.4.4-.4s.5.2.5.4zm4 0c0 .1-.1.3-.3.3-.3 0-.5-.2-.5-.4s.2-.3.5-.3c.2 0 .4.1.4.3zm-1.2 0c0 .2 0 .3-.2.3s-.3-.1-.3-.3.1-.2.3-.2l.2.2zm2.4.1c0 .2 0 .4-.3.4-.1 0-.3-.2-.3-.4s.2-.3.3-.3c.2 0 .3.1.3.3z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 499.9 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#0a328c",
    d: "M249.8 165.7c-2.5 0-4.5 1-4.5 2.1 0 .2 0 .4.2.6.5.6 2.3 1 4.4 1 2 0 3.6-.3 4.2-.9.2-.2.3-.4.3-.7 0-1.1-2-2-4.6-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7c0 .8 2 1.5 4.5 1.5 2.6 0 4.6-.7 4.6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#d20014",
    d: "M245.3 168v1l2.2 7 1.8-5.4 2 5.5 1.3-5.2 1.8 3.5v-1.9l-1.6-3.4a8.3 8.3 0 0 1-.6.2l-1 3.8-1.5-3.6a14.5 14.5 0 0 1-.7 0l-1.5 3.6-1.6-4.4c-.4-.2-.6-.5-.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a328c",
    stroke: "#0a328c",
    d: "M254.4 173.7v1.3c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-1.3c0 .9 2 1.5 4.5 1.5 2.6 0 4.6-.6 4.6-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.7 175-1.1.2v1.3l1.2-.1v-1.3zm-4.8-.1v1.3l1.1.2v-1.3a8.9 8.9 0 0 1-1.1-.2zm-1.6-1.2v1.3c0 .3.2.5.5.7v-1.3c-.3-.2-.5-.4-.5-.7zm9.1.2c0 .2-.4.5-.8.7v1.3c.5-.2.8-.5.8-.9v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M253.4 167.5c0 .5-1.6 1-3.5 1-2 0-3.6-.5-3.6-1s1.6-.9 3.5-.9c2 0 3.6.4 3.6 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.7 168.2.2 1.2h1l.1-1.2h-1.3zm4.1-.3-1 .2.1 1.2 1-.2V168zm-5.4-2-.7.3.1 1 .6-.2v-1zm2.4-.3h-.3l.2 1.2h.6l.2-1.2a9.7 9.7 0 0 0-.7 0zm2.7.4-.1 1 .7.3v-1a5.3 5.3 0 0 0-.6-.3zm-6.5 2.8.2-1.3-1-.5v1.5l.8.3zm8.4-.3v-1.3l-.8.3.8 1zm9.3-8.5c.8 0 2 1 2.1 2.5 0 1-1.7 1-1.7 1 0 .5-1 .9-1.8 1-.8 0 .2-1.5.2-1.5-.5-1.3.2-2.7.2-2.7l1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5 163h.8s0 .3.2.3.3-.4.3-.4h1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d20014",
    stroke: "#f1b517",
    d: "M264.1 160.9c.7-.5.1-1.5-.4-1.5h-1c-.6 0-1.4.6-1.3 1 0 .5.4.7.8.6.2 0 .6-.6.8-.6.3 0 1 .6 1.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M214.2 174.8c-.6.1-.7.8-.5 1.5-2.6.7-5 1.7-7.4 2.4-.1-.5 1.2-1.8 1.2-1.8.3.1.6.9.6.9 0-1.6 1.6-2.6 1.6-2.6-1-.2-3.7 1-4 1.4 0 0 1-.2 1.2 0 0 0-2.2 2.3-2.3 3 .4.7 4 1.3 4 1.3 0 .2-1 1-1 1 1.5.2 3.7-.8 4.3-1.4 0 0-1.7-.2-3-1.3 0 0 .2.7 0 1 0 0-2-.6-2.3-1 0 0 5-1.2 7.4-2 .1.5.6 1.3 1.2 1.1.3-.1.2-.8 0-1.4a.8.8 0 0 0 .6.2c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7a.8.8 0 0 0-.7.5c-.1-.5-.4-1.4-.8-1.3zm2 1.6c0 .2-.2.3-.4.3a.3.3 0 0 1-.4-.3c0-.2.2-.4.4-.4s.3.2.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 177.9c.2-.4 0-2.2 0-2.2-.5 0-1 .7-1 .7.5-1.6-.8-4-.8-4 .9.1 3.9 3 4 3.6 0 0-1.3-.5-1.5-.4.3 1.5 1.3 2.2 1.7 3 0 0-1.7.3-1.6 1.8h-1.1c-.4-.5.1-1.3.1-1.3l-7.7-3.2c-.5-.2-1.6-.8-1.4-1.4.1-.5 2 .3 2.4.5l7 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.6 176.5 1-1.6c.3-.5-.4-1-.9-.4l-1 1.5c-.4.9.5 1.1 1 .5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290.2 288.6-.1-3-3.5.3-.2 3.1 3.8-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.4 292.7-4.7-2.7c19.4 1.8 23.4-5 28.1-5.3 3-.3 3.3 3.2-2.3 1.5l1.5 3.6s-13.8 7.8-27.4 4.6l4.8-1.7zm84.8-4.1.1-3 4.3.2.2 3.1-4.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.9 292 4.5-2.5c-22.4.7-17.3-3.6-28.4-4.8-3-.4-5 3.4 2.2 1.5l-1.4 3.6h3.5c7.6 5 17.8 5.5 24.6 3.9l-5-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5 286.3v5s12.3 4.6 34.4 4.6c22.2 0 34.4-4.6 34.4-4.6v-5s-9.3 4.3-34.4 4.3c-25 0-34.4-4.3-34.4-4.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "m287.3 291.3 1.1-3.7.5.2-1 3.2 2 .5-.2.5-2.4-.7zm3.6-1.6v-.7l.2-.7.6.2-.2.6-.3.7-.3-.1zm5.3-.3.5.2-.4 2.1-.4 1a1.2 1.2 0 0 1-.5.4h-1a2 2 0 0 1-.9-.4 1 1 0 0 1-.4-.6l.1-1 .5-2.2.5.1-.5 2.2a2.1 2.1 0 0 0 0 .8.7.7 0 0 0 .2.4l.5.2h1l.4-1 .4-2.2zm.6 4 .6-3.7h.6l1.5 3.4.5-3h.5l-.6 3.9-.5-.1-1.6-3.3-.5 3-.5-.1zm4 .7.6-3.8h.5l-.5 3.8h-.5zm1.6-1.7c0-.6.3-1.1.7-1.4a2 2 0 0 1 1.4-.4c.4 0 .7.1 1 .3l.5.8c.2.3.2.7.1 1a2.2 2.2 0 0 1-.3 1 1.7 1.7 0 0 1-.8.7 2 2 0 0 1-1 .1 2 2 0 0 1-1-.3 1.7 1.7 0 0 1-.5-.8 2.1 2.1 0 0 1-.1-1zm.5 0c0 .5 0 1 .3 1.2.2.3.5.5.9.5s.7 0 1-.3c.3-.2.4-.6.5-1a1.9 1.9 0 0 0 0-1 1.2 1.2 0 0 0-.5-.5 1.3 1.3 0 0 0-.7-.3c-.3 0-.7 0-1 .3-.2.2-.4.6-.5 1.2zm3.7 2.3.3-3.8h.6l1.8 3.2.2-3h.5l-.3 3.9h-.5l-1.9-3.2-.2 3h-.5zm5.6.4.1-3.8 2.7.1v.5l-2.1-.1-.1 1.1 1.9.1v.5l-2-.1v1.8h-.5zm3 .1 1.5-3.8h.6l1.5 4h-.6l-.4-1.3h-1.7l-.4 1.2h-.6zm1-1.5h1.4l-.4-1a9.8 9.8 0 0 1-.2-.9l-.2.8-.5 1.1zm3.1 1.6v-3.8h.6v3.8h-.6zm2.5 0V292h-1.3v-.4h3.1v.4h-1.3v3.4h-.5zm4 0-.3-4h.6l.1 3.4h2v.4l-2.5.1zm2.6-.2 1.2-4h.6l2 3.7h-.7l-.5-1h-1.7l-.3 1.3h-.6zm1-1.7h1.4l-.5-1-.4-.9a4.8 4.8 0 0 1-.1.8l-.4 1.1zm4.7 1.2-.4-3.8 2.6-.3.1.5-2.1.2v1.2l2-.2v.5l-1.9.2.2 1.7h-.5zm3-2.1a2 2 0 0 1 .2-1.6 2 2 0 0 1 1.3-.7l1 .1c.4.1.6.3.8.6l.4 1-.1 1a1.6 1.6 0 0 1-.6.8 2 2 0 0 1-.9.4 2 2 0 0 1-1-.1 1.7 1.7 0 0 1-.8-.6 2.1 2.1 0 0 1-.4-1zm.5-.1c0 .4.2.8.5 1 .3.3.6.3 1 .3s.7-.2 1-.5c.2-.3.2-.7.2-1.2a2 2 0 0 0-.3-.8 1.3 1.3 0 0 0-.6-.5 1.4 1.4 0 0 0-.7 0c-.4 0-.7.1-1 .4-.1.3-.2.7-.1 1.3zm4.1 1.3-.6-3.8 1.7-.3h.8c.2 0 .4 0 .5.2l.3.6c0 .3 0 .5-.2.7-.1.2-.4.4-.7.5a1.4 1.4 0 0 1 .3.1l.5.5 1 .9h-.7l-.7-.6a7.4 7.4 0 0 0-.5-.5 1.2 1.2 0 0 0-.3-.2.8.8 0 0 0-.3 0h-.3l-.6.1.4 1.7h-.6zm.2-2.2 1-.2a1.7 1.7 0 0 0 .6-.2.6.6 0 0 0 .3-.6.6.6 0 0 0-.2-.4h-.7l-1.3.1.3 1.3zm6.3-.4h.5c0 .4-.1.8-.3 1a2 2 0 0 1-1 .6 2 2 0 0 1-1 0 1.6 1.6 0 0 1-.8-.6 2.6 2.6 0 0 1-.5-1 2.2 2.2 0 0 1 0-1c0-.4.3-.7.5-.9l.9-.4h1c.4.2.6.4.8.8l-.5.2a1.2 1.2 0 0 0-.5-.5 1.1 1.1 0 0 0-.7 0 1 1 0 0 0-.7.3 1.1 1.1 0 0 0-.3.7v.7a2.3 2.3 0 0 0 .4.8c.1.2.3.4.6.4h.7a1.1 1.1 0 0 0 .6-.3c.2-.2.3-.5.3-.8zm1.4 1-1-3.7 2.7-.7.2.4-2.3.6.3 1.1 2.1-.5.2.4-2.2.6.4 1.2 2.4-.6v.4l-2.8.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/ht.7979dcf65e35682bcb8caf203a52e498.svg";
export { ForwardRef as ReactComponent };